import React, { Component } from 'react';

export default class BulkCheckin extends Component {

    render () {
        return <h1>This is the Bulk Checkin page.</h1>
    }

}

